import { render, staticRenderFns } from "./ProveedorList.vue?vue&type=template&id=fe61c678&scoped=true&"
import script from "./ProveedorList.vue?vue&type=script&lang=js&"
export * from "./ProveedorList.vue?vue&type=script&lang=js&"
import style0 from "./ProveedorList.vue?vue&type=style&index=0&id=fe61c678&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe61c678",
  null
  
)

export default component.exports